/* -------------------------------------------------------------
 * Glamm Glow - Premium Custom JS Controller Modules
 * ------------------------------------------------------------- */

const currencySymbol = (window.theme && window.theme.currencySymbol) || '₹';

document.addEventListener('DOMContentLoaded', () => {
  // Initialize Modules
  initCartDrawer();
  initWishlist();
  initAccordions();
  initIngredientTabs();
  initMobileNav();
});

/* =============================================================
 * Cart Drawer & AJAX Cart Engine (Using Native Shopify Cart API)
 * ============================================================= */
function initCartDrawer() {
  const drawer = document.getElementById('cart-drawer');
  const overlay = document.getElementById('cart-drawer-overlay');
  const closeBtn = document.getElementById('cart-drawer-close');
  const openBtns = document.querySelectorAll('.js-cart-open');

  if (!drawer || !overlay) return;

  // Toggle Drawer Open/Close
  const openDrawer = () => {
    drawer.classList.add('active');
    overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
    refreshCart();
  };

  const closeDrawer = () => {
    drawer.classList.remove('active');
    overlay.classList.remove('active');
    document.body.style.overflow = '';
  };

  openBtns.forEach(btn => btn.addEventListener('click', (e) => {
    e.preventDefault();
    openDrawer();
  }));

  closeBtn.addEventListener('click', closeDrawer);
  overlay.addEventListener('click', closeDrawer);

  // Global Dynamic Cart Action Listeners
  document.addEventListener('click', (e) => {
    // Quick Add Product Button
    if (e.target.matches('.js-quick-add-btn')) {
      e.preventDefault();
      const variantId = e.target.getAttribute('data-variant-id');
      if (variantId) {
        addToCart(variantId, 1, openDrawer);
      }
    }
  });
}

// Add Item To Shopify Cart
function addToCart(variantId, quantity = 1, callback = null) {
  const formData = {
    'items': [{
      'id': variantId,
      'quantity': quantity
    }]
  };

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => response.json())
  .then(data => {
    if (callback) callback();
  })
  .catch((error) => {
    console.error('Error adding item to cart:', error);
  });
}

// Add Item To Shopify Cart and Redirect to Checkout (Buy It Now)
function buyItNow(variantId, quantity = 1) {
  const formData = {
    'items': [{
      'id': variantId,
      'quantity': quantity
    }]
  };

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    window.location.href = '/checkout';
  })
  .catch((error) => {
    console.error('Error in Buy It Now:', error);
    window.location.href = `/cart/${variantId}:${quantity}`;
  });
}


// Fetch Cart JSON Data & Redraw Drawer
function refreshCart() {
  fetch('/cart.js')
  .then(response => response.json())
  .then(cart => {
    updateCartCountBadges(cart.item_count);
    drawCartItems(cart);
    updateShippingGoal(cart.total_price);
  })
  .catch(error => console.error('Error refreshing cart:', error));
}

// Update Badges Count
function updateCartCountBadges(count) {
  const badges = document.querySelectorAll('.js-cart-count');
  badges.forEach(badge => {
    badge.textContent = count;
    badge.style.display = count > 0 ? 'flex' : 'none';
  });
}

// Render Items inside Drawer
function drawCartItems(cart) {
  const itemsContainer = document.getElementById('cart-drawer-items');
  const subtotalLabel = document.getElementById('cart-drawer-subtotal');
  
  if (!itemsContainer) return;

  if (cart.items.length === 0) {
    itemsContainer.innerHTML = `<p style="text-align:center; padding: 40px 0; color: var(--color-text-muted);">Your cart is empty.</p>`;
    if (subtotalLabel) subtotalLabel.textContent = currencySymbol + '0.00';
    return;
  }

  let itemsHtml = '';
  cart.items.forEach(item => {
    const formattedPrice = currencySymbol + (item.line_price / 100).toFixed(2);
    const properties = item.variant_title ? `<span class="cart-item-properties">${item.variant_title}</span>` : '';

    itemsHtml += `
      <div class="cart-item" data-key="${item.key}">
        <div class="cart-item-media">
          <img src="${item.image}" alt="${item.title}">
        </div>
        <div class="cart-item-info">
          <h4 class="cart-item-title">${item.product_title}</h4>
          ${properties}
          <div class="cart-item-price-row">
            <div class="cart-item-qty">
              <button class="cart-item-qty-btn js-qty-adjust" data-change="-1">-</button>
              <input type="text" class="cart-item-qty-val" value="${item.quantity}" readonly>
              <button class="cart-item-qty-btn js-qty-adjust" data-change="1">+</button>
            </div>
            <span style="font-weight:600;">${formattedPrice}</span>
          </div>
          <button class="cart-item-remove js-cart-item-remove">Remove</button>
        </div>
      </div>
    `;
  });

  itemsContainer.innerHTML = itemsHtml;
  if (subtotalLabel) subtotalLabel.textContent = currencySymbol + (cart.total_price / 100).toFixed(2);

  // Hook Quantity Adjustment Buttons
  itemsContainer.querySelectorAll('.js-qty-adjust').forEach(btn => {
    btn.addEventListener('click', (e) => {
      const itemRow = e.target.closest('.cart-item');
      const itemKey = itemRow.getAttribute('data-key');
      const change = parseInt(e.target.getAttribute('data-change'));
      const input = itemRow.querySelector('.cart-item-qty-val');
      const newQty = Math.max(0, parseInt(input.value) + change);

      changeQuantity(itemKey, newQty);
    });
  });

  // Hook Remove Buttons
  itemsContainer.querySelectorAll('.js-cart-item-remove').forEach(btn => {
    btn.addEventListener('click', (e) => {
      const itemRow = e.target.closest('.cart-item');
      const itemKey = itemRow.getAttribute('data-key');
      changeQuantity(itemKey, 0);
    });
  });
}

// Change quantity in Shopify Session
function changeQuantity(itemKey, quantity) {
  const data = {
    id: itemKey,
    quantity: quantity
  };

  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  })
  .then(response => response.json())
  .then(cart => {
    refreshCart();
  })
  .catch(error => console.error('Error changing cart quantity:', error));
}

// Update free shipping goal indicator
function updateShippingGoal(totalPriceCents) {
  const fill = document.getElementById('shipping-progress-fill');
  const textLabel = document.getElementById('shipping-status-text');
  
  if (!fill || !textLabel) return;

  const thresholdContainer = document.getElementById('cart-drawer');
  const thresholdINR = thresholdContainer ? parseInt(thresholdContainer.getAttribute('data-threshold')) : 499;
  const thresholdCents = thresholdINR * 100;

  if (totalPriceCents >= thresholdCents) {
    fill.style.width = '100%';
    textLabel.innerHTML = 'You have unlocked <strong>Free Shipping!</strong>';
  } else {
    const diff = (thresholdCents - totalPriceCents) / 100;
    const pct = Math.min(100, (totalPriceCents / thresholdCents) * 100);
    fill.style.width = pct + '%';
    textLabel.innerHTML = `Spend <strong>${currencySymbol}${diff.toFixed(2)}</strong> more for <strong>Free Shipping!</strong>`;
  }
}

/* =============================================================
 * Wishlist Module (Using Browser LocalStorage)
 * ============================================================= */
const WISHLIST_KEY = 'glammglow_wishlist_items';

function initWishlist() {
  updateWishlistCountBadges();

  // Toggle active icons status on products load
  document.querySelectorAll('.js-wishlist-toggle').forEach(btn => {
    const productId = btn.getAttribute('data-product-id');
    if (!productId) return;
    
    if (isItemWishlisted(productId)) {
      btn.classList.add('active');
    }

    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      
      toggleWishlist(productId);
      btn.classList.toggle('active');
      
      // Heart Pulse Animation
      btn.style.transform = 'scale(1.2)';
      setTimeout(() => btn.style.transform = '', 200);
    });
  });
}

function getWishlist() {
  try {
    const val = localStorage.getItem(WISHLIST_KEY);
    return val ? JSON.parse(val) : [];
  } catch (err) {
    return [];
  }
}

function isItemWishlisted(productId) {
  const wishlist = getWishlist();
  return wishlist.includes(productId);
}

function toggleWishlist(productId) {
  let wishlist = getWishlist();
  if (wishlist.includes(productId)) {
    wishlist = wishlist.filter(id => id !== productId);
  } else {
    wishlist.push(productId);
  }
  localStorage.setItem(WISHLIST_KEY, JSON.stringify(wishlist));
  updateWishlistCountBadges();
}

function updateWishlistCountBadges() {
  const count = getWishlist().length;
  const badges = document.querySelectorAll('.js-wishlist-count');
  badges.forEach(badge => {
    badge.textContent = count;
    badge.style.display = count > 0 ? 'flex' : 'none';
  });
}

// Expose updates to window scope for page interactions
window.updateWishlistCountBadges = updateWishlistCountBadges;


/* =============================================================
 * Accordions Controller Module (Product Tabs details)
 * ============================================================= */
function initAccordions() {
  const headers = document.querySelectorAll('.js-accordion-header');

  headers.forEach(header => {
    header.addEventListener('click', () => {
      const item = header.closest('.accordion-item');
      const content = item.querySelector('.accordion-content');
      const isActive = item.classList.contains('active');

      // Close other accordions in the same group if needed
      const parent = item.closest('.accordion');
      if (parent) {
        parent.querySelectorAll('.accordion-item').forEach(other => {
          if (other !== item) {
            other.classList.remove('active');
            other.querySelector('.accordion-content').style.maxHeight = null;
          }
        });
      }

      // Toggle Active content height
      if (isActive) {
        item.classList.remove('active');
        content.style.maxHeight = null;
      } else {
        item.classList.add('active');
        content.style.maxHeight = content.scrollHeight + 'px';
      }
    });
  });
}

/* =============================================================
 * Ingredient Spotlight Tab Selector Module
 * ============================================================= */
function initIngredientTabs() {
  const tabs = document.querySelectorAll('.js-ingredient-tab');
  const panels = document.querySelectorAll('.js-ingredient-panel');

  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      const targetId = tab.getAttribute('data-target');

      // Update tabs state
      tabs.forEach(t => t.classList.remove('active'));
      tab.classList.add('active');

      // Update panels visibility
      panels.forEach(panel => {
        if (panel.id === targetId) {
          panel.classList.add('active');
        } else {
          panel.classList.remove('active');
        }
      });
    });
  });
}

/* =============================================================
 * Mobile Navigation Drawer Toggle
 * ============================================================= */
function initMobileNav() {
  const toggleBtn = document.querySelector('.js-mobile-nav-toggle');
  const closeBtn = document.querySelector('.js-mobile-nav-close');
  const drawer = document.getElementById('MobileNavDrawer');
  const overlay = document.getElementById('MobileNavOverlay');

  if (!drawer || !toggleBtn) return;

  const openNav = () => {
    drawer.classList.add('active');
    if (overlay) overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  };

  const closeNav = () => {
    drawer.classList.remove('active');
    if (overlay) overlay.classList.remove('active');
    document.body.style.overflow = '';
  };

  toggleBtn.addEventListener('click', (e) => {
    e.preventDefault();
    openNav();
  });

  if (closeBtn) {
    closeBtn.addEventListener('click', (e) => {
      e.preventDefault();
      closeNav();
    });
  }

  if (overlay) {
    overlay.addEventListener('click', closeNav);
  }
}
